module.exports = __webpack_public_path__ + "static/media/bank.a62ca9ce.svg";